import type { FC } from 'react';
import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Label } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';
import { useFormatDate } from '@pflegenavi/frontend/localization';
import { YEAR_MONTH_DAY_FORMAT } from '@pflegenavi/shared/constants';
import { InfoBoxContainer } from '../InfoBox';
import PaymentFailedImage from '../../../assets/undraw_payment_failed.svg';

interface DisabledPaymentForNursingHomeInfoBoxProps {
  until?: Date;
}

export const DisabledPaymentForNursingHomeInfoBox: FC<
  DisabledPaymentForNursingHomeInfoBoxProps
> = ({ until }) => {
  return (
    <InfoBoxContainer
      image={
        <img
          src={PaymentFailedImage}
          alt=""
          width={210}
          style={{ marginTop: 30 }}
        />
      }
      content={<DisabledPaymentForNursingHomeContent until={until} />}
    />
  );
};

const DisabledPaymentForNursingHomeContent: FC<{ until?: Date }> = ({
  until,
}) => {
  const { t } = useTranslation();
  const fDate = useFormatDate();

  return (
    <>
      <Label
        sx={{
          mb: 2,
          p: 1.8,
        }}
        variant="filled"
        color="info"
      >
        {t('mobile.family-member.disabled-payment')}
      </Label>
      <Stack direction="row" justifyContent="center">
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            fontWeight: 700,
          }}
        >
          {t('mobile.family-member.disabled-payment')}
        </Typography>
      </Stack>

      <Typography variant="subtitle1">
        {until
          ? t('mobile.family-member.payments-disabled-for-nursing-home-until', {
              date: fDate(until, YEAR_MONTH_DAY_FORMAT),
            })
          : t('mobile.family-member.payments-disabled-for-nursing-home')}
      </Typography>
    </>
  );
};
